<template lang="html">
  <div class="builder-tip" v-html="htmlContent"></div>
</template>

<script>
export default {
  name: 'Tooltip',

  props: {
    content: String
  },

  computed: {
    htmlContent() {
      return `<p>${this.content}</p>`
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.builder-tip
  background: #fff
  position: fixed
  bottom: calc(100% + 15px)
  width: 290px
  height: 100px
  display: flex
  align-items: center
  line-height: 1.6
  padding: 8px
  border-radius: 5px
  font-size: 16px
  z-index: 1
  border: 1px solid #f3f3f3
  box-shadow: 0 0 5px #ededed
  white-space: normal

  @include themify($themes)
    color: themed('color-body')
</style>
